var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "curr-month-overview" }, [
    _c("div", { staticClass: "body-title flex-center" }, [
      _vm._v("《" + _vm._s(_vm.monthReportTitle) + "》"),
    ]),
    _vm._m(0),
    _c("div", { staticClass: "overview-list flex-between" }, [
      _c("div", { staticClass: "overview-list-item" }, [
        _vm._m(1),
        _c(
          "div",
          { staticStyle: { transform: "translateY(-15px)" } },
          [
            _c("CountAnimation", {
              staticClass: "count-bold",
              staticStyle: { color: "#1062fe" },
              attrs: {
                "end-val": Number(_vm.dataSource.schoolAvgEmotionValue),
                attr: { decimals: 2 },
              },
            }),
            _c("div", {
              staticStyle: { margin: "5px 0" },
              domProps: {
                innerHTML: _vm._s(
                  _vm.dataSource.schoolHistoryAvgEmotionValueStr
                ),
              },
            }),
            _c("div", [
              _c("span", [
                _vm._v(
                  _vm._s(_vm.dataSource.gradeEmotionTop) +
                    "最高 " +
                    _vm._s(_vm.dataSource.gradeEmotionTopValue)
                ),
              ]),
              _vm._v("\n          ｜\n          "),
              _c("span", [
                _vm._v(
                  _vm._s(_vm.dataSource.gradeEmotionLow) +
                    "最低 " +
                    _vm._s(_vm.dataSource.gradeEmotionLowValue)
                ),
              ]),
            ]),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "overview-list-item" }, [
        _vm._m(2),
        _c("div", { staticStyle: { transform: "translateY(-15px)" } }, [
          _c(
            "div",
            [
              _c("CountAnimation", {
                staticClass: "count-bold",
                attrs: { "end-val": Number(_vm.dataSource.remindStudentCount) },
              }),
              _vm._v("\n          人\n        "),
            ],
            1
          ),
          _c("div", { staticStyle: { margin: "5px 0" } }, [
            _c("span", [
              _vm._v(
                _vm._s(_vm.dataSource.twoRemindStudentCount) + " 人两次提醒"
              ),
            ]),
            _vm._v("\n          ｜\n          "),
            _c("span", [
              _vm._v(
                _vm._s(_vm.dataSource.threeRemindStudentCount) + " 人三次及以上"
              ),
            ]),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "overview-list-item" }, [
        _vm._m(3),
        _c("div", { staticStyle: { transform: "translateY(-15px)" } }, [
          _c(
            "div",
            [
              _c("CountAnimation", {
                staticClass: "count-bold",
                attrs: {
                  "end-val": _vm.dataSource.moodContinuedLowModelStudentCount,
                },
              }),
              _vm._v("\n          名\n        "),
            ],
            1
          ),
          _c("div", { staticStyle: { margin: "5px 0" } }, [
            _c("span", { staticStyle: { color: "#ff4646" } }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.faceCollectInfo.faceNotGatherCount) +
                  " 名未采集数据\n          "
              ),
            ]),
            _vm._v("\n          ｜\n          "),
            _c("span", [_vm._v("需重点核实")]),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "overview-list-item" }, [
        _vm._m(4),
        _c("div", { staticStyle: { transform: "translateY(-15px)" } }, [
          _c(
            "div",
            [
              _c("CountAnimation", {
                staticClass: "count-bold",
                attrs: {
                  "end-val": Number(_vm.dataSource.remindDealRate),
                  attr: { decimals: 2 },
                },
              }),
              _vm._v("\n          %\n        "),
            ],
            1
          ),
          _c("div", { staticStyle: { margin: "5px 0" } }, [
            _c("span", [
              _vm._v(
                "未处理 " + _vm._s(_vm.dataSource.remindNotDealRate) + "%"
              ),
            ]),
          ]),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "text-area" }, [
      _vm._m(5),
      _c("div", { staticClass: "text-content" }, [
        _c("div", { staticClass: "summary-section flex-align-center" }, [
          _c("img", {
            staticClass: "section-icon",
            attrs: {
              src: require("@/assets/imgs/school/monthRecord/emotion_overview.png"),
              alt: "",
            },
          }),
          _c("div", { staticClass: "section-body" }, [
            _c("div", { staticClass: "section-title" }, [
              _vm._v("一、情绪总览"),
            ]),
            _c("div", { staticClass: "section-item" }, [
              _vm._v("\n            全校本月平均情绪指数"),
              _c("span", { staticClass: "hl" }, [
                _vm._v(_vm._s(_vm.emotionIndex)),
              ]),
              _vm._v("，相比于上月情绪指数整体"),
              _c("span", { staticClass: "hl" }, [
                _vm._v(_vm._s(_vm.emotionChangeRate)),
              ]),
              _vm._v("，各个班中情绪指数最高的班级为"),
              _c("span", { staticClass: "hl" }, [
                _vm._v(_vm._s(_vm.top3ClassesText)),
              ]),
            ]),
            _c("div", { staticClass: "section-item" }, [
              _vm._v("\n            显开心的日期"),
              _c("span", { staticClass: "hl" }, [
                _vm._v(_vm._s(_vm.happiestDate)),
              ]),
              _vm._v("，最开心的时间段\n            "),
              _c("span", { staticClass: "hl" }, [
                _vm._v(_vm._s(_vm.happiestTimePeriod)),
              ]),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "summary-section flex-align-center" }, [
          _c("img", {
            staticClass: "section-icon",
            attrs: {
              src: require("@/assets/imgs/school/monthRecord/care_details.png"),
              alt: "",
            },
          }),
          _c("div", { staticClass: "section-body" }, [
            _c("div", { staticClass: "section-title" }, [
              _vm._v("二、关怀详情"),
            ]),
            _c("div", { staticClass: "section-item" }, [
              _vm._v("\n            全校本月共提醒 "),
              _c("span", { staticClass: "hl" }, [
                _vm._v(_vm._s(_vm.remindTotal)),
              ]),
              _vm._v(" 人，其中\n            "),
              _c("span", { staticClass: "hl" }, [
                _vm._v(
                  _vm._s(_vm.twoRemindCount) +
                    " 人两次提醒，" +
                    _vm._s(_vm.threeRemindCount) +
                    "\n              人三次以上提醒，重点关注学生提醒 " +
                    _vm._s(_vm.keyCareRemindCount) +
                    " 人"
                ),
              ]),
              _vm._v("，较于上月提醒名单趋势"),
              _c("span", { staticClass: "hl" }, [
                _vm._v(_vm._s(_vm.remindTrend)),
              ]),
            ]),
            _c("div", { staticClass: "section-item" }, [
              _vm._v("\n            本月"),
              _c("span", { staticClass: "hl" }, [
                _vm._v("整体关怀率 " + _vm._s(_vm.careRate)),
              ]),
              _vm.gradeCareRateText
                ? _c("span", [
                    _vm._v("，"),
                    _c("span", { staticClass: "hl" }, [
                      _vm._v(_vm._s(_vm.gradeCareRateText)),
                    ]),
                  ])
                : _vm._e(),
            ]),
            _c(
              "div",
              { staticClass: "section-item" },
              [
                _vm._v("\n            本月影响学生情绪的因素有："),
                _vm._l(_vm.reasonList, function (item, index) {
                  return _c("span", { key: `${item.name}-${index}` }, [
                    _c("span", { staticClass: "hl" }, [
                      _vm._v(
                        _vm._s(item.name) + "（" + _vm._s(item.ratio) + "）"
                      ),
                    ]),
                    index !== _vm.reasonList.length - 1
                      ? _c("span", [_vm._v("、")])
                      : _vm._e(),
                  ])
                }),
              ],
              2
            ),
          ]),
        ]),
        _c("div", { staticClass: "summary-section flex-align-center" }, [
          _c("img", {
            staticClass: "section-icon",
            attrs: {
              src: require("@/assets/imgs/school/monthRecord/teacher_management.png"),
              alt: "",
            },
          }),
          _c("div", { staticClass: "section-body" }, [
            _c("div", { staticClass: "section-title" }, [
              _vm._v("三、教师管理"),
            ]),
            _c("div", { staticClass: "teacher-cols" }, [
              _c("div", [
                _c("div", { staticClass: "section-item" }, [
                  _vm._v("\n                本月班主任登录"),
                  _c("span", { staticClass: "hl" }, [
                    _vm._v(
                      "使用最多的前三名分别是" +
                        _vm._s(_vm.mostUsedClassNamesText)
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "section-item" }, [
                  _vm._v("\n                本月"),
                  _c("span", { staticClass: "hl" }, [
                    _vm._v(
                      "班主任关怀率最高的前三名是" +
                        _vm._s(_vm.highestCareRateClassNamesText)
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "section-item" }, [
                  _vm._v("\n                本月"),
                  _c("span", { staticClass: "hl" }, [
                    _vm._v(
                      "没有提醒的班级是" + _vm._s(_vm.notRemindedClassNamesText)
                    ),
                  ]),
                ]),
              ]),
              _c("div", [
                _c("div", { staticClass: "section-item" }, [
                  _c("span", { staticClass: "hl" }, [
                    _vm._v(
                      "本月班主任家访 " +
                        _vm._s(_vm.teacherHomeVisitCount) +
                        "次，心理老师家访\n                  " +
                        _vm._s(_vm.psychologistHomeVisitCount) +
                        "次"
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "section-item" }, [
                  _c("span", { staticClass: "hl" }, [
                    _vm._v(
                      "本月班主任主动关怀" +
                        _vm._s(_vm.headTeacherActiveCareCount) +
                        "次，心理老师主动辅导\n                  " +
                        _vm._s(_vm.psychologistActiveCounselingCount) +
                        "次"
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "flex-align-center",
        staticStyle: { "margin-bottom": "20px" },
      },
      [
        _c("img", {
          staticStyle: {
            width: "24px",
            height: "20px",
            "margin-right": "15px",
          },
          attrs: {
            src: require("@/assets/imgs/school/monthRecord/dashboard.png"),
            alt: "",
          },
        }),
        _c("div", { staticClass: "record-title" }, [_vm._v("本月概览")]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-title" }, [
      _c("div", [_vm._v("全校平均情绪指数")]),
      _c("img", {
        staticClass: "item-icon",
        attrs: {
          src: require("@/assets/imgs/school/monthRecord/line.png"),
          alt: "",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-title" }, [
      _c("div", [_vm._v("情绪提醒总数")]),
      _c("img", {
        staticClass: "item-icon",
        attrs: {
          src: require("@/assets/imgs/school/monthRecord/remind.png"),
          alt: "",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-title" }, [
      _c("div", [_vm._v("低活跃度学生")]),
      _c("img", {
        staticClass: "item-icon",
        attrs: {
          src: require("@/assets/imgs/school/monthRecord/figure.png"),
          alt: "",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-title" }, [
      _c("div", [_vm._v("提醒处理率")]),
      _c("img", {
        staticClass: "item-icon",
        attrs: {
          src: require("@/assets/imgs/school/monthRecord/love.png"),
          alt: "",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text-header flex-between" }, [
      _c("div", { staticClass: "flex-align-center" }, [
        _c("img", {
          staticStyle: { width: "24px", height: "24px", "margin-right": "5px" },
          attrs: { src: require("@/assets/imgs/school/monthRecord/panel.png") },
        }),
        _c("span", { staticClass: "title-1", staticStyle: { color: "#fff" } }, [
          _vm._v("本月总结"),
        ]),
        _c("span", { staticClass: "title-3", staticStyle: { color: "#fff" } }, [
          _vm._v(
            "｜本月工作中，我们共同呵护着每一位学生的心理状态，也见证了各班级在心理关怀上的积极努力。"
          ),
        ]),
      ]),
      _c("img", {
        staticStyle: { width: "208px", height: "100%" },
        attrs: {
          src: require("@/assets/imgs/school/monthRecord/screenshot.png"),
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }